import { ReactComponent as CartCircleIcon } from "../../assets/icons/cart-circle.svg";
import { ReactComponent as CheckedCircleIcon } from "../../assets/icons/checked-circle.svg";
import { Badge, BasicCard, CardContent, CardDescription, CardHeader } from "./styles";
import { applicationPath } from "common/src/routes/explorer";
import { ProjectBanner, ProjectLogo } from "./ProjectBanner";
import { usePostHog } from "posthog-js/react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ApplicationCard(props) {
  const {
    application,
    inCart,
    onAddToCart: addToCart,
    onRemoveFromCart: removeFromCart
  } = props;
  const posthog = usePostHog();
  const roundId = application.roundId.toLowerCase();
  return /*#__PURE__*/_jsxs(BasicCard, {
    className: "w-full hover:opacity-90 transition hover:shadow-none",
    children: [/*#__PURE__*/_jsxs("a", {
      target: "_blank",
      href: applicationPath({
        chainId: application.chainId,
        roundId,
        applicationId: application.roundApplicationId
      }),
      "data-track-event": "project-card",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        className: "relative",
        children: /*#__PURE__*/_jsx(ProjectBanner, {
          bannerImgCid: application.bannerImageCid,
          classNameOverride: "bg-black h-[120px] w-full object-cover rounded-t",
          resizeHeight: 120
        })
      }), /*#__PURE__*/_jsxs(CardContent, {
        className: "relative",
        children: [application.logoImageCid !== null && /*#__PURE__*/_jsx(ProjectLogo, {
          className: "border-solid border-2 border-white absolute -top-[24px] ",
          imageCid: application.logoImageCid,
          size: 48
        }), /*#__PURE__*/_jsx("div", {
          className: "truncate mt-4",
          children: application.name
        }), /*#__PURE__*/_jsx(CardDescription, {
          className: " min-h-[96px]",
          children: /*#__PURE__*/_jsx("div", {
            className: "text-sm line-clamp-4",
            children: application.summaryText
          })
        }), /*#__PURE__*/_jsx(Badge, {
          color: "grey",
          rounded: "3xl",
          children: /*#__PURE__*/_jsx("span", {
            className: "truncate",
            children: application.roundName
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-2",
      children: /*#__PURE__*/_jsx("div", {
        className: "border-t pt-2 flex justify-end",
        children: inCart ? /*#__PURE__*/_jsx("button", {
          "aria-label": "Remove from cart",
          onClick: () => {
            posthog.capture("application_removed_from_cart", {
              applicationRef: application.applicationRef
            });
            removeFromCart(application);
          },
          children: /*#__PURE__*/_jsx(CheckedCircleIcon, {
            className: "w-10"
          })
        }) : /*#__PURE__*/_jsx("button", {
          "aria-label": "Add to cart",
          onClick: () => {
            posthog.capture("application_added_to_cart", {
              applicationRef: application.applicationRef
            });
            addToCart(application);
          },
          children: /*#__PURE__*/_jsx(CartCircleIcon, {
            className: "w-10"
          })
        })
      })
    })]
  });
}